const routes = {
  CONTACT: "/kontakt",
  PROFILE: "/profil",
  REGISTER_MEMBER: "/bli-medlem",
  NEWS_ARCHIVE: "/aktuelt",
  USER: "/user",
  LOGIN: "/login",
  SEARCH: "/sok",
  PREVIEW: "/preview",
  LOG_IN: "/meg",
  BOARD_PORTAL: "https://styreportalen.bob.no",
};

export default routes;
